<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Ir para tela de compras"
    ocultar-acoes
  >
    <template #ativador>
      <v-btn icon @click="buscarComparacaoProdutos();">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </template>

    <sys-data-table
      :headers="cabecalhos"
      :height="300"
      :item-height="40"
      :items="fornecedores"
      hide-default-footer
    >
      <template #item.acos="{ item }">
        <v-btn icon @click="pushTelaCompras(item)">
          <v-icon>mdi-cart</v-icon>
        </v-btn>
      </template>
    </sys-data-table>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";
import store from "@/store";
import * as req from "@/api/Produtos/DemandaCombinada";
import {arrayColumn, buscarCompraFornecedor, logout} from "@/helpers";

const props = defineProps({
  id_grupo: Number,
  produtos: Array,
  id_produto_combinado: String,
  nome_produto_combinado: String,
});

const cabecalhos = [
  { text: 'Id', value: 'idfornecedor' },
  { text: 'Nome Fornecedor', value: 'descricao_fornecedor' },
  { text: 'Ações', value: 'acos', style: { width: '50px' } },
];

const dialog_ativo = ref(false);
const fornecedores = ref([]);

function buscarComparacaoProdutos() {
  const parametros = {
    idgrupo: props.id_grupo,
    filial: 0,
    id_produto_combinado: props.id_produto_combinado
  };

  store.dispatch('loading/addRequisicao',
    req.buscarComparacaoProdutos(parametros)
      .then(produtos => {
        const produtos_sem_totalizador = produtos.filter(item => item.idproduto !== '-');
        fornecedores.value = removerFornecedoresDuplicados(arrayColumn(produtos_sem_totalizador, ['idfornecedor', 'descricao_fornecedor']));

        if (fornecedores.value.length === 1) {
          pushTelaCompras(fornecedores.value[0]);
        } else {
          dialog_ativo.value = true;
        }
      })
      .catch(logout)
  );
}

function removerFornecedoresDuplicados(itens) {
  const itens_unicos = [];

  for (const item of itens) {
    if (itens_unicos.some(_item => _item.idfornecedor === item.idfornecedor)) continue;
    itens_unicos.push(item);
  }

  return itens_unicos;
}

function pushTelaCompras(item) {
  const fornecedor_selecionado = {
    id: item.idfornecedor,
    razao_social: item.descricao_fornecedor,
    produto: {
      id_produto: props.id_produto_combinado,
      nome_produto: props.nome_produto_combinado,
    },
  };

  buscarCompraFornecedor(fornecedor_selecionado, 1);
}
</script>
